'use client';

import { removeJWT } from '@/services/jwt';
import { analytics } from '@/services/analytics';
import { QueryClient } from '@tanstack/react-query';

export type SignOutOptions = {
  queryClient: QueryClient;
  redirectUrl?: string;
};

export function signOut({
  queryClient,
  redirectUrl = '/volunteer'
}: SignOutOptions) {
  removeJWT();
  queryClient.clear();

  // Clear analytics user context on logout
  analytics.anonymize();

  window.location.href = redirectUrl;
}
